/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethod/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Email from './Email/index'
import No from './No/index'
import Phone from './Phone/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ContactMethod({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/ContactMethod"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentPlanRequestContactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_request',
path: 'contact_method_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: treatmentPlanRequestContactMethodTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Email'}>
<Email
  viewPath={`${viewPath}/Email`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Phone'}>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}